import Text from 'components/Text/Text';
import React from 'react';
import { Checkbox, Form } from 'antd';

interface ISendingReportAfterShiftClosingCheckbox {
	toggleSendingReportAfterShiftClosing: () => void;
	sendingReportAfterShiftClosing: boolean;
	disabled: boolean;
}

const SendingReportAfterShiftClosingCheckbox: React.FC<ISendingReportAfterShiftClosingCheckbox> = ({
	toggleSendingReportAfterShiftClosing,
	sendingReportAfterShiftClosing,
	disabled,
}) => {
	return (
		<Form.Item name="sendingReportAfterShiftClosing">
			<Checkbox
				checked={sendingReportAfterShiftClosing}
				onChange={toggleSendingReportAfterShiftClosing}
				disabled={disabled}>
				<Text translationNameSpace="form" translationKey="sendingReportAfterShiftLabel" asFragment={true} />
			</Checkbox>
		</Form.Item>
	);
};

export default React.memo(SendingReportAfterShiftClosingCheckbox);
